// import React, { useState, useEffect, memo, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import SimpleReactValidator from 'simple-react-validator';
// import API from "api.js";
// import PhoneInputField from 'components/Inputs/PhoneInputField';
// import {
// 	Modal
// } from "reactstrap";
// import popupLogo from "assets/images/logol.png";

// class BookNowModal extends React.Component {
// 	constructor(props) {
//         super(props);
//         this.state = {
//             isOpen: false,
//             name: "",
//             phone: "",
//             email: "",
//             center: "",
//             process: false,
// 			branches:[]
//         }
//         this.validator = new SimpleReactValidator();
//     }

//     componentDidMount() {
// 		this.getBranches();
// 		console.log("This are Props : ",this.props);
//     }

//     getBranches = () => {
// 		API({
// 			url: "getAllBranches",
// 			method: "GET",
// 		}).then((res) => {
// 			if (res.status && res.status === 200) {
// 				this.setState({
// 					branches: res.data.branches
// 				});
// 			}
// 		});
// 	}

// 	changeInput = (e) => {
//         let { name, value } = e.target;
//         this.setState({ [name] : value });
//     };

//     handlePhoneChange = (event) => {
//     	this.setState({phone: event});
//     }

//     postSubmit = (e) => {
// 		if (!this.validator.allValid()) {
// 			this.validator.showMessages();
// 			this.forceUpdate();
// 			return false;
// 		}

//         e.preventDefault();
//         this.setState({ process: true }, async () => {

// 			let bodyFormData = new FormData();
// 	        bodyFormData.append('phone', this.state.phone);
// 	        bodyFormData.append('name', this.state.name);
// 	        bodyFormData.append('email', this.state.email);
// 	        bodyFormData.append('center', this.state.center);
// 	        let res = null;
// 	        try {
// 				res = await API({
// 					method: 'POST',
// 					url: '/submit-query',
// 					data: bodyFormData
// 				});
// 	        } catch(error) {
// 	            this.setState({ process: false });
// 	            return "l";
// 	        };

// 	        if (res.status === 200) {
// 				this.props.navigate({
// 					pathname: '/trial-class-thankyou',
// 					state: {
// 						flag: true
// 					}
// 				});
// 				this.setState({
// 					indexModal: false
// 				});
// 			} else if (res.response.status === 422) {
// 				this.setState({
// 					error: res.response,
// 					process: false
// 				});
				
// 				let str = '';
// 				Object.values(this.state.error.data.errors).forEach((val) => {
// 					str += val[0]+'\n';
// 				});
// 				this.setState({
// 					error_bag: str
// 				});
// 			}
//         });
// 	}

// 	render() {

// 		const { isOpen, toggle } = this.props;
// 		const { branches } = this.state;

// 		return (
// 			<Modal isOpen={isOpen} size="lg" id="anouncementPopup" >
// 				<div className="modal-content">
// 					<div className="modal-header" hidden="">
// 						<a
// 							onClick={toggle}
// 							style={{
// 								color: '#93c13e',
// 								opacity: 'unset'
// 							}}
// 							href="javascript:void(0)"
// 							className="close"
// 							data-dismiss="modal"
// 							aria-label="Close"
// 						>
// 							<span aria-hidden="true">×</span>
// 						</a>
// 					</div>

// 					<div className="modal-body pte_popup_modal_body">
// 						<div className="row">
// 							<div className="col-md-6 col-sm-6 col-xs-12">
// 								<img className="pte-popup-logo-img" style={{width: '100px'}} src={popupLogo} />
// 								<p className="pte_popup_modal_ptag"></p>
// 								<div>
// 									<h2 className="pte_popup_modal_h2tag pte_popup_modal_h2tagl1" style={{textAlign: 'center', fontSize:'23px', margin: '30px 0px 0px 0px', padding: '0px',fontWeight:'700'}}>Attend a </h2>
// 									<h2 className="pte_popup_modal_h2tag pte_popup_modal_h2tagl2" style={{fontSize: '27px',fontStyle: 'italic',margin:'5px 0px',textAlign: 'center'}}><b style={{color:'#a7ff00'}}>FREE TRIAL CLASS</b> </h2>
// 									<h2 className="pte_popup_modal_h2tag pte_popup_modal_h2tagl3" style={{textAlign: 'center', fontSize: '23px', margin: '0px', padding: '0px',color: 'black'}}>for PTE, NAATI CCL or IELTS with us.</h2>
// 								</div>
// 							</div>

// 							<div className="col-md-6 col-sm-6 col-xs-12 pte_popup_modal_seccol">
// 								<div className="pte_popup_modal_sec_inner_col">
// 									<h4 className="pte_popup_modal_h4tag" style={{textAlign: 'center'}}>Book NOW!</h4>
// 									<p className="pte_popup_modal_ptag" style={{textAlign: 'center'}}>Submit Your Details Below</p>
// 									<p className="pte_popup_modal_ptag" style={{textAlign: 'center'}}><i className="fas fa-long-arrow-alt-down"></i></p>
// 									<div className="pte-popup-form-start">
// 										<form onSubmit={this.postSubmit}>
// 											<div className="col-md-12">
// 												<input
// 													className="ptepop_name form-control"
// 													onChange={this.changeInput}
// 													value={this.state.name}
// 													name="name"
// 													placeholder="Name*"
// 													type="text"
// 												/>
// 												{this.validator.message('name', this.state.name, 'required')}
// 											</div>
// 											<div className="col-md-12">
// 												<div className="pte-modal-inputf-gap" style={{height: '10px'}}></div>
// 												<PhoneInputField
// 													value={this.state.phone}
// 													changeEvent={this.handlePhoneChange}
// 													addClass="popup-class"
// 													countryCodeBg={true}
// 												/>
// 												{this.validator.message('phone', this.state.phone, 'required|phone')}
// 											</div>
// 											<div className="col-md-12">
// 												<div className="pte-modal-inputf-gap" style={{height: '10px'}}></div>
// 												<input
// 													className="form-control ptepop_email"
// 													name="email"
// 													onChange={this.changeInput}
// 													value={this.state.email}
// 													placeholder="Email Address*"
// 													type="email"
// 												/>
// 												{this.validator.message('email', this.state.email, 'required|email')}
// 											</div>
// 											<div className="col-md-12">
// 												<div className="pte-modal-inputf-gap" style={{height: '10px'}}></div>
// 												<select
// 													className="form-control ptepop_email"
// 													name="center"
// 													onChange={this.changeInput}
// 													value={this.state.center}
// 												>
// 													<option value="">Select center</option>
// 													{branches.map((branch) => (
// 														<React.Fragment key={branch.id}>
// 															{branch.branch_detail?.title &&
// 																<option value={branch.branch_detail.title}>
// 														 			{branch.branch_detail.title}
// 																</option>
// 															}
// 														</React.Fragment>
// 													))}
// 												</select>
// 												{this.validator.message('center', this.state.center, 'required')}
// 											</div>
// 											<div className="col-md-12 row_before_pte_submit">
// 												<div className="pte-modal-inputf-gap" style={{height: '10px'}}></div>
// 												{!this.state.process &&
// 													<a onClick={this.postSubmit} className="btn btn-primary pte_popup_modal_submit">Submit</a>
// 												}
// 												{this.state.process &&
// 													<a className="btn btn-primary pte_popup_modal_submit">Wait...</a>
// 												}
// 											</div>
// 										</form>
// 									</div>
// 									<div className="pte-modal-inputf-gap" style={{height: '10px'}}></div>
// 								</div>
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 			</Modal>
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import SimpleReactValidator from 'simple-react-validator';
import API from "api.js";
import PhoneInputField from 'components/Inputs/PhoneInputField';
import { Modal } from "react-bootstrap";
import popupLogo from "assets/images/logol.png";

const BookNowModal = (props) => {
    const navigate = useNavigate();

    // const [isOpen, setIsOpen] = useState(false); // managed by parent via props
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [center, setCenter] = useState("");
    const [process, setProcess] = useState(false);
    const [branches, setBranches] = useState([]);
    const [error, setError] = useState(null);
    const [error_bag, setErrorBag] = useState("");
    // const [indexModal, setIndexModal] = useState(false); // was set but never read in render

    // Using useRef to persist validator instance across renders
    const validator = useRef(new SimpleReactValidator());
    const [, forceUpdate] = useState(0); // used to trigger re-render for validator messages

    useEffect(() => {
        getBranches();
        console.log("This are Props : ", props);
    }, []);

    const getBranches = () => {
        API({
            url: "getAllBranches",
            method: "GET",
        }).then((res) => {
            if (res.status && res.status === 200) {
                setBranches(res.data.branches);
            }
        });
    };

    const changeInput = (e) => {
        const { name, value } = e.target;
        if (name === "name") setName(value);
        if (name === "email") setEmail(value);
        if (name === "center") setCenter(value);
    };

    const handlePhoneChange = (event) => {
        setPhone(event);
    };

    const postSubmit = (e) => {
        e.preventDefault();
        if (!validator.current.allValid()) {
            validator.current.showMessages();
            forceUpdate(n => n + 1);
            return false;
        }

        setProcess(true);

        (async () => {
            let bodyFormData = new FormData();
            bodyFormData.append('phone', phone);
            bodyFormData.append('name', name);
            bodyFormData.append('email', email);
            bodyFormData.append('center', center);

            let res = null;
            try {
                res = await API({
                    method: 'POST',
                    url: '/submit-query',
                    data: bodyFormData
                });
            } catch (error) {
                setProcess(false);
                return "l";
            };

            if (res.status === 200) {
                navigate('/trial-class-thankyou', {
                    state: { flag: true }
                });
                // setIndexModal(false); // was set after successful submission
            } else if (res.response.status === 422) {
                const errorResponse = res.response;
                setError(errorResponse);
                setProcess(false);

                let str = '';
                Object.values(errorResponse.data.errors).forEach((val) => {
                    str += val[0] + '\n';
                });
                setErrorBag(str);
            }
        })();
    };

    const { isOpen, toggle } = props;

    return (
        <Modal show={isOpen} onHide={toggle} size="lg" id="booknowpopup" centered dialogClassName="booknow-modal-dialog">
            <div className="modal-content booknow-modal-content">
                <a
                    onClick={toggle}
                    href="javascript:void(0)"
                    className="booknow-close"
                    aria-label="Close"
                >
                    <span aria-hidden="true">
                        <img className="img-fluid" alt="LA" src="/images/web-new-images/icons/close-icon2.svg" />
                    </span>
                </a>

                <div className="modal-body p-0 booknow-modal-body">
                    <div className="booknow-form-outer m-0">
                        <div className="booknow-form-content">
                            <div className="booknow-left-img booknow-form-img">
                                <img className="img-fluid" alt="LA" src="/images/web-new-images/hero_img-02.png" />
                                <h4 className="booknow-left-title">Attend a FREE TRIAL CLASS for PTE, NAATI CCL or IELTS with us.</h4>
                            </div>

                            <div className="booknow-right-content">
                                <h4 className="booknow-title">Book Now</h4>
                                <p className="booknow-subtitle">Submit Your Details Below</p>

                                <div className="pte-popup-form-start">
                                    <form onSubmit={postSubmit}>
                                        <div className="col-md-12">
                                            <div className="booknow-field">
                                                <label htmlFor="booknow-name">Name*</label>
                                                <div className="booknow-input-outer">
                                                    <input
                                                        id="booknow-name"
                                                        className="booknow-input"
                                                        placeholder="Enter Name"
                                                        type="text"
                                                        value={name}
                                                        name="name"
                                                        onChange={changeInput}
                                                    />
                                                </div>
                                                {validator.current.message('name', name, 'required|alpha_space|max:30')}
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="booknow-field">
                                                <label htmlFor="booknow-phone">Phone Number*</label>
                                                <div className="booknow-phone-outer">
                                                    <PhoneInputField
                                                        value={phone}
                                                        changeEvent={handlePhoneChange}
                                                        addClass="popup-class"
                                                        countryCodeBg={true}
                                                    />
                                                </div>
                                                {validator.current.message('phone', phone, 'required|phone')}
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="booknow-field">
                                                <label htmlFor="booknow-email">Email*</label>
                                                <div className="booknow-input-outer">
                                                    <input
                                                        id="booknow-email"
                                                        className="booknow-input"
                                                        placeholder="Enter Email"
                                                        type="email"
                                                        value={email}
                                                        name="email"
                                                        onChange={changeInput}
                                                    />
                                                </div>
                                                {validator.current.message('email', email, 'required|email')}
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="booknow-field">
                                                <label htmlFor="booknow-center">Center*</label>
                                                <div className="booknow-input-outer booknow-select-outer">
                                                    <select
                                                        id="booknow-center"
                                                        className="booknow-input"
                                                        name="center"
                                                        onChange={changeInput}
                                                        value={center}
                                                    >
                                                        <option value="" disabled>Select center</option>
                                                        {branches.map((branch) => (
                                                            <React.Fragment key={branch.id}>
                                                                {branch.name &&
                                                                    <option value={branch.name}>
                                                                        {branch.name}
                                                                    </option>
                                                                }
                                                            </React.Fragment>
                                                        ))}
                                                    </select>
                                                </div>
                                                {validator.current.message('center', center, 'required')}
                                            </div>
                                        </div>

                                        <div className="col-md-12 row_before_pte_submit">
                                            {!process &&
                                                <button type="submit" className="booknow-primary-btn">
                                                    SUBMIT
                                                    <img alt="LA" src="/images/web-new-images/right-arrow.svg" />
                                                </button>
                                            }
                                            {process &&
                                                <button type="button" className="booknow-primary-btn" disabled>
                                                    Wait...
                                                </button>
                                            }
                                        </div>
                                    </form>
                                </div>

                                <div className="pte-modal-inputf-gap" style={{ height: '10px' }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default BookNowModal;